import React from "react";
import { Container } from "./styles";
import { useAppStore } from "../../stores/appStore";
import classNames from "classnames";

/** @param {{ message: string, url: string, buttonText: string, role?: import("react").AriaRole }} props */
const EditorMessage = ({ message, url, buttonText, role = undefined }) => {
  const isSW2 = useAppStore((state) => state.isSW2);

  return (
    <Container role={role} className={classNames("editor-message", { sw2: isSW2 })}>
      <p>{message}</p>
      <button
        onClick={(e) => {
          e.preventDefault();
          window.location.href = url;
        }}
      >
        {buttonText}
      </button>
    </Container>
  );
};

export default EditorMessage;
